// Maps a user role to its home surface. Shared by login/2FA redirects.
export function roleHome(role) {
  if (role === "admin") return "/admin";
  if (role === "attorney") return "/attorney";
  if (role === "affiliate") return "/affiliate/dashboard";
  return "/dashboard";
}
